module.exports = {
      id: "0652ce842e06599a75737c55a73f25ccconstruction-brick.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#0652ce842e06599a75737c55a73f25ccconstruction-brick.svg",
      toString: function () {
        return this.url;
      }
    }